var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5614 30C20.593 30 19.6328 29.8288 18.6939 29.4877C14.5574 27.985 10.7179 25.5377 7.59033 22.4101C4.46272 19.2826 2.01536 15.443 0.512785 11.3066C0.0299342 9.97729 -0.11256 8.60508 0.0894043 7.22795C0.278596 5.938 0.778263 4.68573 1.53444 3.60647C2.29396 2.52247 3.30654 1.62087 4.46266 0.999158C5.69554 0.336197 7.04121 0 8.4624 0C8.90441 0 9.28643 0.308835 9.37906 0.741005L10.8505 7.60785C10.9171 7.9188 10.8216 8.24234 10.5968 8.46721L8.08244 10.9815C10.4543 15.6973 14.3031 19.546 19.0189 21.9179L21.5331 19.4036C21.758 19.1788 22.0816 19.0833 22.3925 19.1498L29.2593 20.6213C29.6916 20.7139 30.0003 21.0959 30.0003 21.5379C30.0003 22.9591 29.6641 24.3049 29.0011 25.5377C28.3794 26.6939 27.4778 27.7064 26.3938 28.466C25.3146 29.2221 24.0623 29.7218 22.7723 29.911C22.3681 29.9704 21.964 29.9999 21.5614 30ZM7.71337 1.91594C5.83874 2.12288 4.17486 3.10546 3.06995 4.68244C1.82746 6.45571 1.53772 8.63678 2.27504 10.6665C5.16382 18.6189 11.3816 24.8366 19.334 27.7254C21.3636 28.4627 23.5447 28.1731 25.318 26.9305C26.895 25.8256 27.8776 24.1617 28.0845 22.2871L22.4984 21.0901L19.8725 23.7159C19.5931 23.9953 19.1686 24.0696 18.811 23.9015C13.2337 21.2813 8.71915 16.7667 6.09894 11.1894C5.93096 10.8318 6.00514 10.4073 6.28456 10.1279L8.91039 7.50209L7.71337 1.91594Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6bb0b8c88e851b07d1dfff5dde5ef5d1.svg";
export { ForwardRef as ReactComponent };